import { setClientGlobalConfig } from "@imi/api-client/client.js";
import { jwtDecode } from "jwt-decode";
import { User } from "oidc-client-ts";
import { LoaderFunctionArgs, redirect } from "react-router";
import { oidcStorage } from "./core/auth/oidcConfig";

export function appLoader({ request }: LoaderFunctionArgs) {
  setClientGlobalConfig({
    authToken: getAccessToken(request.url) || undefined,
    baseURL: import.meta.env.VITE_API_BASE_URL,
  });
  return {};
}

function getAccessToken(redirectUrl: string): string | null {
  const oidcKey = Object.keys(oidcStorage).find((key) =>
    key.startsWith("oidc.user:"),
  );
  if (!oidcKey) return null;

  const raw = oidcStorage.getItem(oidcKey);
  if (!raw) return null;

  const user = User.fromStorageString(raw);
  if (!user) {
    oidcStorage.removeItem(oidcKey);
    throw redirect("/auth/login");
  }

  const decoded = jwtDecode(user.access_token);
  if (!decoded.exp) {
    oidcStorage.removeItem(oidcKey);
    throw redirect("/auth/login");
  }

  const expMs = decoded.exp * 1000;
  const now = Date.now();
  const url = new URL(redirectUrl);
  if (expMs < now) {
    oidcStorage.removeItem(oidcKey);
    throw redirect(
      `/auth/silent-renew?redirectUrl=${encodeURIComponent(url.pathname)}`,
    );
  }

  return user.access_token;
}
